import { Grid, makeStyles, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@material-ui/core';
import React, { useContext, useEffect, useState } from 'react';
import styled from 'styled-components';
import ReactHtmlParser from 'react-html-parser';
import { URLContext } from '../../../contexts/URLContext';
import Loader from '../../components/Loader';

const MyParagraph = styled(Typography)`
  margin-bottom: 16px;
`;

const useStyles = makeStyles({
  table: {
    margin: "16px auto",
    width: "96%",
  },
  header: {
    fontWeight: "bold",
    backgroundColor: 'var(--lightbg)',
  }
});

const RegulationContent = () => {
  const { baseURL } = useContext(URLContext);
  const classes = useStyles();
  const [ regulationData, setRegulationData ] = useState(null);
  const [ isLoaded, setIsLoaded ] = useState(false);
  const [ errorMessage, setErrorMessage ] = useState("");

  useEffect(() => {
    const controller = new AbortController();

    fetch( baseURL + 'regulation.json' )
    // fetch( './regulation.json' )
      .then( (response) => response.json())
      .then(data => {
        setRegulationData(data);
        setIsLoaded(true);
      })
      .catch((error) => {
        console.log(error);
        setErrorMessage("Erro ao carregar as informações")
      });

    return () => {
      controller.abort();
    }
  }, [baseURL])

  return(
    <>
      {!isLoaded ? (
        <Loader message={errorMessage} />
      ):(
        <>
          <Grid container justify="center">
            <Grid item xs={3}>
              <img src="./assets/selo-republica.png" alt="República Federativa do Brasil" style={{ width: "100%", marginBottom: 16 }} />
            </Grid>
          </Grid>
          { regulationData && regulationData.map((data, index) => (
            <div key={`container${Math.random()}`}>
              { ( data.type === "text" || data.type === "title" ) && (
                <MyParagraph
                  key={`text${index + Math.random()}`}
                  variant={data.type === "title" ? "body1" : "body2"}
                  className={`dark--text ${data.type === "title" && "bold-text"}`}
                  align={data.type === "title" ? "center" : "left"}
                  gutterBottom
                >
                  {ReactHtmlParser(data.content)}
                </MyParagraph>
              )}
              { data.type === "table" && (
                <TableContainer className={classes.table} component={Paper}>
                  <Table aria-label="simple table">
                    <TableHead className={classes.header}>
                      <TableRow>
                        { data.headers.map ( (header, index) => (
                          <TableCell
                            key={`header${index + Math.random()}`}
                            className="bold-text primary--text"
                          >
                            {header}
                          </TableCell>
                        ))}
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      { data.content.map ( (line, index) => (
                        <TableRow
                          key={`line${index + Math.random()}`}
                        >
                          { (Object.keys(data.content[index]).map((cell, index) => (
                            <TableCell
                              key={`cell${index + Math.random()}`}
                              align="left"
                              className="primary-light--text"
                            >
                              {line[cell]}
                            </TableCell>
                          )))}
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              )}
              { data.type === "signature" && (
                <Grid container spacing={1}>
                  <Grid item xs={3}>
                    <img src={baseURL + data.image} alt={data.content} style={{width: "80%"}} />
                  </Grid>
                  <Grid item xs={9}>
                    <div style={{ border: "1px solid #7B8F9B", padding: 8 }}>
                      <MyParagraph variant="body2" className="dark--text" style={{ wordWrap: 'break-word', margin: 0 }}>
                        {data.content}
                      </MyParagraph>
                    </div>
                  </Grid>
                </Grid>
              )}
            </div>
          ))}
        </>
      )}
    </>
  );
}

export default RegulationContent;